import { useCallback, useState } from "react";
import submit from "submit-form";

const COACHING_STYLES = [
  { key: "generalPopulation", label: "General Population" },
  { key: "femaleFitness", label: "Female Fitness" },
  { key: "powerlifting", label: "Powerlifting" },
  { key: "hybridTraining", label: "Hybrid Training" },
  { key: "olympicWeightlifting", label: "Olympic Weightlifting" },
  { key: "bodybuilding", label: "Bodybuilding / Hypertrophy" },
  { key: "strongman", label: "Strongman" },
  { key: "metcons", label: "Metcons / CrossFit" },
];

/**
 * Coaching style picker grid — shown when demo account has not been seeded yet.
 * On selection, POSTs to seed the demo account with the chosen style.
 *
 * @param {Object} props
 * @param {string} props.athleteId - Demo athlete's _id
 */
export default function DemoStylePicker({ athleteId }) {
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSelect = useCallback(
    (styleKey) => {
      if (loading) return;
      setSelected(styleKey);
    },
    [loading]
  );

  const handleSeed = useCallback(() => {
    if (!selected || loading) return;
    setLoading(true);
    submit("/coaching-portal/athletes/seed-demo", {
      method: "POST",
      body: { athleteId, style: selected },
    });
  }, [selected, loading, athleteId]);

  return (
    <div className="demo-style-picker">
      <p className="demo-style-picker__prompt">
        Pick a coaching style to populate the demo account with realistic
        training data:
      </p>
      <div className="demo-style-picker__grid">
        {COACHING_STYLES.map(({ key, label }) => (
          <button
            key={key}
            type="button"
            className={`demo-style-picker__option${selected === key ? " demo-style-picker__option--selected" : ""}`}
            onClick={() => handleSelect(key)}
            disabled={loading}
          >
            {label}
          </button>
        ))}
      </div>
      <button
        type="button"
        data-button-type="primary"
        className="demo-style-picker__confirm"
        onClick={handleSeed}
        disabled={!selected || loading}
      >
        {loading ? "Seeding demo account…" : "Seed demo account"}
      </button>
    </div>
  );
}
